var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_vm.SHARE_STATE.show ? _c('div', {
    directives: [{
      name: "preventWindowScrolling",
      rawName: "v-preventWindowScrolling"
    }],
    staticClass: "modal-conteiner"
  }, [_c('div', {
    staticClass: "modal-frame",
    on: {
      "click": function click($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.SET_MODAL_PARAMS({
          type: 'SHARE',
          params: {
            show: false
          }
        });
      }
    }
  }, [_c('div', {
    staticClass: "modal-inner-container"
  }, [_c('div', [_c('div', [_c('form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.sendBill($event);
      }
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "container margin-bottom-two"
  }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('share.on.social.media')))])]), _c('socials-share', {
    attrs: {
      "url": _vm.SHARE_STATE.shareInfo.url,
      "title": _vm.SHARE_STATE.shareInfo.title,
      "description": _vm.SHARE_STATE.shareInfo.description
    }
  })], 1)]), _c('fieldset', [_vm.SHARE_STATE.shareInfo.showForm ? _c('div', {
    staticClass: "container"
  }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('send.to.email')))])]), _c('InputEmail', {
    ref: "email",
    attrs: {
      "input-id": "input-email",
      "input-name": _vm.$t('send.to.email'),
      "input-title": _vm.$t('indicate.electronic.mail'),
      "input-header": _vm.$t('send.to.email'),
      "input-placeholder": _vm.$t('enter.email'),
      "button-text": _vm.$t('common.send'),
      "required": ""
    },
    on: {
      "buttonClicked": _vm.sendBill
    },
    model: {
      value: _vm.email,
      callback: function callback($$v) {
        _vm.email = $$v;
      },
      expression: "email"
    }
  })], 1) : _vm._e()])])])])])])]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }